module.exports = __webpack_public_path__ + "static/img/rppghealthapp2.0596cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/rppghealthapp2.png
// module id = Vusk
// module chunks = 5